<template>
  <b-card class="pt-0" style="background-color: #fafbfe">
    <b-row>
      <b-col class="p-0">
        <div class="mb-4 ml-4 mr-4">
          <b-row>
            <b-col md="3">
              <b-button
                size="sm"
                @click="backButton"
                class="mr-2 my-0 main-navigation-button"
                variant="light"
              >
                <i class="fa fa-arrow-left" aria-hidden="false"></i>
              </b-button>
              <h4 style="display: inline-block">Create Advertisement</h4>
            </b-col>
          </b-row>
          <v-stepper
            alt-labels
            v-model="currentstepper"
            style="border-radius: 12px"
          >
            <v-stepper-header
              style="padding: 0px 200px; background-color: #fafbfe"
            >
              <v-stepper-step step="1" class="v-stepper-step-outline"
                >Basic Info & Target</v-stepper-step
              >
              <v-divider />
              <v-stepper-step step="2" class="v-stepper-step-outline"
                >Banner Details</v-stepper-step
              >
            </v-stepper-header>
            <loader v-if="loading"></loader>

            <v-stepper-items>
              <v-stepper-content step="1" style="background-color: #fafbfe">
                <div>
                  <b-card border-variant="info" style="border-radius: 12px">
                    <b-row>
                      <b-col md="12">
                        <h5>Select banner Type & Placement</h5>
                      </b-col>
                      <b-col md="6">
                        <eb-select
                          type="text"
                          v-model="inputObject.type"
                          :options="adtypes"
                          label="label"
                          placeholder="Select Type (Banner, Slider, Video)"
                          @input="changeType"
                        ></eb-select>
                      </b-col>
                      <b-col
                        md="6"
                        v-if="$currentUserData.category !== 'SELLER'"
                      >
                        <eb-select
                          type="text"
                          v-model="inputObject.placement"
                          :options="placementList"
                          label="label"
                          placeholder="Select Placement From List"
                        ></eb-select>
                      </b-col>
                      <b-col
                        md="6"
                        v-if="this.$currentUserData.category === 'SELLER'"
                      >
                        <eb-select
                          type="text"
                          v-model="inputObject.placement"
                          :options="placementListseller"
                          label="placement"
                          placeholder="Select Placement From List"
                        ></eb-select>
                      </b-col>
                    </b-row>
                    <hr class="my-4" />
                    <b-row>
                      <b-col md="12">
                        <label class="labelFont" for=""
                          >Select Visibility Type</label
                        >
                      </b-col>
                      <b-col
                        :md="
                          inputObject.target.visibility == '' ||
                          inputObject.target.visibility.type == 'GLOBAL'
                            ? 6
                            : 4
                        "
                      >
                        <eb-select
                          v-model="inputObject.target.visibility.type"
                          placeholder="Select Type (Where you want to place this Banner)"
                          type="text"
                          label="name"
                          :options="visibilityOptions"
                          @input="changeVisibility($event)"
                        ></eb-select>
                      </b-col>
                      <b-col
                        md="4"
                        v-if="
                          inputObject.target.visibility &&
                          inputObject.target.visibility.type === 'PROVIDER'
                        "
                      >
                        <eb-select
                          placeholder="Select Partner"
                          type="text"
                          v-model="visibilityType"
                          :options="partnerList"
                          label="userName"
                          @input="changePartner($event)"
                        ></eb-select>
                      </b-col>
                      <b-col
                        md="4"
                        v-if="
                          inputObject.target.visibility &&
                          inputObject.target.visibility.type === 'MARKET'
                        "
                      >
                        <eb-select
                          placeholder="Select Market"
                          class="mb-0"
                          type="text"
                          v-model="visibilityType"
                          :options="catalogList"
                          label="label"
                          @input="changeMarket($event)"
                        ></eb-select>
                      </b-col>
                      <b-col
                        :md="
                          inputObject.target.visibility == '' ||
                          inputObject.target.visibility.type == 'GLOBAL'
                            ? 6
                            : 4
                        "
                      >
                        <eb-select
                          type="text"
                          v-model="inputObject.target.displayFrequency"
                          :options="frequencyOptions"
                          label="label"
                          placeholder="Select Frequency (in Sec)"
                        ></eb-select>
                      </b-col>
                    </b-row>
                    <hr class="my-4" />
                    <b-row class="mb-4">
                      <b-col md="12">
                        <h5>Select Display Period</h5>
                      </b-col>
                      <b-col md="3">
                        <label class="labelFont" for="pickStartDate"
                          >Start Date</label
                        >
                        <b-input
                          id="pickStartDate"
                          type="date"
                          v-model="inputObject.duration.startDate"
                        ></b-input>
                      </b-col>
                      <b-col md="3">
                        <label class="labelFont" for="pickEndDate"
                          >End Date</label
                        >
                        <b-input
                          id="pickEndDate"
                          type="date"
                          v-model="inputObject.duration.endDate"
                        ></b-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <input
                          type="checkbox"
                          id="advSetting"
                          value=""
                          v-model="advanceSetting"
                          @change="handleAdvanceSetting"
                        />
                        <label for="advSetting" class="pl-1 pr-3 labelFont"
                          >Advance Setting</label
                        >
                      </b-col>
                    </b-row>
                    <b-row v-if="advanceSetting">
                      <b-col md="3">
                        <label class="labelFont" for="pickStartTime"
                          >Start Time</label
                        >
                        <b-input
                          id="pickStartTime"
                          type="time"
                          v-model="inputObject.target.timeRange[0].start"
                        ></b-input>
                      </b-col>
                      <b-col md="3">
                        <label class="labelFont" for="pickEndTime"
                          >End Time</label
                        >
                        <b-input
                          id="pickEndTime"
                          type="time"
                          v-model="inputObject.target.timeRange[0].end"
                        ></b-input>
                      </b-col>
                    </b-row>
                    <b-row v-if="advanceSetting">
                      <b-col class="pt-3">
                        <template>
                          <input
                            type="checkbox"
                            id="allDays"
                            v-model="allChecked"
                            @change="handleChecked"
                            unchecked
                          />
                          <label for="allDays" class="pl-1 pr-5 labelFont"
                            >Select all</label
                          >
                          <input
                            type="checkbox"
                            id="monday"
                            value="Monday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="monday" class="pl-1 pr-5 labelFont"
                            >Monday</label
                          >
                          <input
                            type="checkbox"
                            id="tuesday"
                            value="Tuesday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="tuesday" class="pl-1 pr-5 labelFont"
                            >Tuesday</label
                          >
                          <input
                            type="checkbox"
                            id="wednesday"
                            value="Wednesday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="wednesday" class="pl-1 pr-5 labelFont"
                            >Wednesday</label
                          >
                          <input
                            type="checkbox"
                            id="Thursday"
                            value="Thursday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="Thursday" class="pl-1 pr-5 labelFont"
                            >Thursday</label
                          >
                          <input
                            type="checkbox"
                            id="friday"
                            value="Friday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="friday" class="pl-1 pr-5 labelFont"
                            >Friday</label
                          >
                          <input
                            type="checkbox"
                            id="saturday"
                            value="Saturday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="saturday" class="pl-1 pr-5 labelFont"
                            >Saturday</label
                          >
                          <input
                            type="checkbox"
                            id="sunday"
                            value="Sunday"
                            v-model="inputObject.target.days"
                            @change="handleUnChecked"
                          />
                          <label for="sunday" class="pl-1 pr-5 labelFont"
                            >Sunday</label
                          >
                        </template>
                      </b-col>
                    </b-row>
                    <hr class="my-4" />
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="10">
                            <label class="labelFont" for=""
                              >Select Target Location</label
                            >
                          </b-col>
                        </b-row>
                        <b-form-group>
                          <GmapAutocomplete
                            @place_changed="placechange"
                            :position="position"
                            :placeholder="'Select Target Location'"
                            :options="{
                              fields: [
                                'geometry',
                                'formatted_address',
                                'address_components',
                              ],
                            }"
                            class="mt-1 location-search"
                          ></GmapAutocomplete>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-row class="mb-1">
                          <b-col md="10">
                            <label class="labelFont" for=""
                              >Select Age Range</label
                            >
                          </b-col>
                          <b-col>
                            <input
                              type="checkbox"
                              id="checkRange"
                              value=""
                              v-model="selectAge"
                            />
                            <label class="labelFont pl-1" for="checkRange"
                              >Enable</label
                            >
                          </b-col>
                        </b-row>
                        <b-row v-if="selectAge">
                          <b-col md="6">
                            <b-input
                              id="start-date"
                              type="number"
                              placeholder="Mininum Age"
                              v-model="inputObject.target.ageGroup.min"
                            ></b-input>
                          </b-col>
                          <b-col md="6">
                            <b-input
                              id="end-date"
                              type="number"
                              placeholder="Maximum Age"
                              v-model="inputObject.target.ageGroup.max"
                            ></b-input>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card>
                  <b-row class="text-align-center justify-content-center">
                    <b-col md="3">
                      <b-button
                        class="btn btn-block my-3"
                        btn-color="secondary"
                        @click="backButton"
                        >CANCEL</b-button
                      >
                    </b-col>
                    <b-col md="3">
                      <b-button
                        class="btn btn-block my-3"
                        btn-color="primary"
                        @click="nextPage"
                        >CONTINUE</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
              </v-stepper-content>
              <v-stepper-content step="2" style="background-color: #fafbfe">
                <div class="sliderButton pb-2">
                  <b-dropdown
                    v-if="
                      inputObject.type && inputObject.type.value === 'SLIDER'
                    "
                    class="sliderOption"
                    variant="primary"
                    right
                    text="+ ADD NEW SLIDER "
                  >
                    <b-dropdown-item @click="addNewBannerSlider('BANNER')"
                      >ADD NEW BANNER SLIDER</b-dropdown-item
                    >
                    <b-dropdown-item @click="addNewVideoSlider('VIDEO')"
                      >ADD NEW VIDEO SLIDER</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <div>
                  <b-card
                    border-variant="info"
                    style="border-radius: 10px; margin-bottom: 0px"
                    v-if="inputObject.type != ''"
                  >
                    <div v-for="(data, idx) in inputObject.data" :key="idx">
                      <b-row
                        class="pb-3"
                        v-if="
                          inputObject.type.value === 'SLIDER' &&
                          bannerType != ''
                        "
                      >
                        <b-col md="9">
                          <label class="pt-1"> Banner {{ idx + 1 }} </label>
                        </b-col>

                        <b-col
                          md="2"
                          style="display: flex; justify-content: right"
                        >
                          <b-button variant="danger" @click="removeBanner(idx)">
                            <span>
                              <i class="fa fa-minus" aria-hidden="true"></i>
                              &nbsp; &nbsp;
                            </span>
                            REMOVE SLIDER
                          </b-button>
                        </b-col>
                        <b-col
                          md="1"
                          style="display: flex; justify-content: center"
                        >
                          <b-button
                            v-b-toggle:aria-controls="`collapse-${idx}`"
                            variant="light"
                          >
                            <i
                              class="fa fa-solid fa-angle-down when-open"
                              aria-hidden="true"
                            ></i>
                            <i
                              class="fa fa-solid fa-angle-up when-closed"
                              aria-hidden="true"
                            ></i
                          ></b-button>
                        </b-col>
                      </b-row>
                      <b-collapse visible :id="`collapse-${idx}`">
                        <b-row
                          v-if="
                            (inputObject.type &&
                              inputObject.type.value === 'VIDEO') ||
                            (inputObject.type.value === 'SLIDER' &&
                              bannerType[idx] === 'VIDEO')
                          "
                        >
                          <b-col>
                            <label
                              class="labelFont mt-2"
                              style="padding-right: 60px"
                              >Select Video Type
                            </label>
                            <input
                              type="radio"
                              :id="`deviceVideo${idx}`"
                              value="UPLOADED"
                              v-model="data.video.type"
                              @change="hideSelectedVideo(data)"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`deviceVideo${idx}`"
                              >Upload From Device</label
                            >
                            <input
                              type="radio"
                              :id="`urlVideo${idx}`"
                              value="YOUTUBE"
                              v-model="data.video.type"
                              @change="hideSelectedVideo(data)"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`urlVideo${idx}`"
                              >3ed Party Video URL</label
                            >
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="
                            inputObject.type.value === 'BANNER' ||
                            inputObject.type.value === 'VIDEO' ||
                            (inputObject.type.value === 'SLIDER' &&
                              (bannerType[idx] === 'BANNER' ||
                                bannerType[idx] === 'VIDEO'))
                          "
                          class="justify-content-between"
                        >
                          <b-col
                            md="9"
                            v-if="
                              (inputObject.type &&
                                inputObject.type.value === 'BANNER') ||
                              (inputObject.type.value === 'SLIDER' &&
                                bannerType[idx] === 'BANNER')
                            "
                            @click="clickUploadImage(idx)"
                          >
                            <b-form-group
                              class="labelFont"
                              label="Upload Image"
                              label-for="Image"
                              :id="`Image${idx}`"
                              :label-cols="7"
                            ></b-form-group>
                            <single-image
                              :for="`Image${idx}`"
                              :url="data.image && data.image.fileUrl"
                              class="singleImage"
                              label="Choose an Advertisement Image"
                            ></single-image>
                            <input
                              :for="`Image${idx}`"
                              style="display: none"
                              :ref="`imageUploader${idx}`"
                              type="file"
                              @change="readImage($event, idx)"
                            />
                          </b-col>
                          <b-col
                            md="9"
                            v-if="
                              (inputObject.type &&
                                inputObject.type.value === 'VIDEO' &&
                                data.video.type === 'UPLOADED') ||
                              (inputObject.type.value === 'SLIDER' &&
                                bannerType[idx] === 'VIDEO' &&
                                data.video.type === 'UPLOADED')
                            "
                            @click="clickUploadVideo(idx)"
                          >
                            <b-form-group
                              class="labelFont"
                              label="Upload Video"
                              label-for="VideoUpLoad"
                              :id="`VideoUpLoad${idx}`"
                              :label-cols="7"
                            ></b-form-group>
                            <single-video
                              :for="`VideoUpLoad${idx}`"
                              :url="data.video.url"
                              class="singleImage"
                              label="Choose an Advertisement Video"
                              @change="readVideo($event, idx)"
                            ></single-video>
                            <input
                              :for="`VideoUpLoad${idx}`"
                              style="display: none"
                              :ref="`videoUploader${idx}`"
                              type="file"
                              @change="readVideo($event, idx)"
                            />
                          </b-col>
                          <b-col
                            md="6"
                            v-if="
                              (inputObject.type &&
                                inputObject.type.value === 'VIDEO' &&
                                data.video.type === 'YOUTUBE') ||
                              (inputObject.type.value === 'SLIDER' &&
                                bannerType[idx] === 'VIDEO' &&
                                data.video.type === 'YOUTUBE')
                            "
                          >
                            <b-form-group
                              class="labelFont"
                              label="Enter Video URL"
                              label-for="Videourl"
                              id="Videourl"
                              :label-cols="7"
                            ></b-form-group>
                            <b-form-input
                              inputType="text"
                              v-model="data.video.url"
                              placeholder="Enter Video URL"
                            ></b-form-input>
                          </b-col>
                          <b-col
                            md="2"
                            v-if="
                              inputObject.type.value === 'BANNER' ||
                              inputObject.type.value === 'VIDEO' ||
                              (inputObject.type.value === 'SLIDER' &&
                                (bannerType[idx] === 'BANNER' ||
                                  bannerType[idx] === 'VIDEO'))
                            "
                            @click="$refs.iconUploader[idx].click()"
                          >
                            <b-form-group
                              class="labelFont"
                              label="Choose an Icon Image"
                              label-for="Icon"
                              id="Icon"
                              :label-cols="7"
                            ></b-form-group>
                            <single-image
                              :url="
                                inputObject.icon && inputObject.icon.fileUrl
                              "
                              class="singleIcon"
                              label="Choose an Advertisement Icon"
                            ></single-image>
                            <input
                              style="display: none"
                              ref="iconUploader"
                              type="file"
                              @change="readIcon($event)"
                            />
                          </b-col>
                        </b-row>
                        <b-row class="mb-4">
                          <b-col
                            class="mt-2"
                            v-if="
                              (inputObject.type &&
                                inputObject.type.value === 'VIDEO') ||
                              (inputObject.type.value === 'SLIDER' &&
                                bannerType[idx] === 'VIDEO')
                            "
                          >
                            <input
                              type="checkbox"
                              id="videoSound"
                              v-model="muteSound"
                            />
                            <label for="videoSound" class="pl-1 pr-4 labelFont"
                              >Mute Video Sound</label
                            >
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="
                            inputObject.type.value === 'BANNER' ||
                            (inputObject.type.value === 'SLIDER' &&
                              bannerType[idx] === 'BANNER')
                          "
                        >
                          <b-col md="4">
                            <label class="labelFont" for=""
                              >Enter Banner Content</label
                            >
                          </b-col>
                          <b-col
                            md="3"
                            v-if="
                              inputObject.type.value === 'BANNER' ||
                              inputObject.type.value === 'VIDEO' ||
                              (inputObject.type.value === 'SLIDER' &&
                                bannerType != '')
                            "
                          >
                            <eb-select
                              class="mb-0"
                              type="text"
                              v-model="data.lang"
                              :options="languageOptions"
                              label="label"
                              placeholder="Select Language"
                            ></eb-select>
                          </b-col>
                          <b-col style="text-align: right">
                            <label class="labelFont" style="padding-right: 30px"
                              >Select Text Position
                            </label>
                            <input
                              type="radio"
                              id="textLeft"
                              value="LEFT"
                              v-model="data.contentPosition"
                            />
                            <label class="pl-1 pr-3 labelFont" for="textLeft"
                              >Left</label
                            >
                            <input
                              type="radio"
                              id="textRight"
                              value="RIGHT"
                              v-model="data.contentPosition"
                            />
                            <label class="pl-1 pr-3 labelFont" for="textRight"
                              >Right</label
                            >
                            <input
                              type="radio"
                              id="textCenter"
                              value="CENTER"
                              v-model="data.contentPosition"
                            />
                            <label class="pl-1 pr-3 labelFont" for="textCenter"
                              >Center</label
                            >
                          </b-col>
                        </b-row>
                        <b-row
                          class="pt-3"
                          v-if="
                            inputObject.type.value === 'BANNER' ||
                            (inputObject.type.value === 'SLIDER' &&
                              bannerType[idx] === 'BANNER')
                          "
                        >
                          <b-col>
                            <vue-editor v-model="data.text"></vue-editor>
                          </b-col>
                        </b-row>
                        <b-row
                          v-if="
                            inputObject.type.value === 'BANNER' ||
                            inputObject.type.value === 'VIDEO' ||
                            (inputObject.type.value === 'SLIDER' &&
                              bannerType != '')
                          "
                        >
                          <b-col md="6" class="my-2">
                            <b-row>
                              <b-col>
                                <label class="labelFont"
                                  >Select Navigation Criteria
                                </label>
                              </b-col>
                            </b-row>
                            <input
                              type="radio"
                              :id="`navigationUrl${idx}`"
                              value="navUrl"
                              v-model="data.radioCriteria"
                              @change="hideCustomCriteria(data)"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`navigationUrl${idx}`"
                              >Navigation URL</label
                            >
                            <input
                              type="radio"
                              :id="`customCriteria${idx}`"
                              value="customCri"
                              v-model="data.radioCriteria"
                              @change="hideNavUrl(data)"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`customCriteria${idx}`"
                              >Search Criteria</label
                            >
                          </b-col>
                          <b-col
                            md="6"
                            class="my-2"
                            v-if="data.radioCriteria == 'navUrl'"
                          >
                            <b-row>
                              <b-col>
                                <label class="labelFont"
                                  >Enter Navigation URL
                                </label>
                              </b-col>
                            </b-row>
                            <b-form-input
                              inputType="text"
                              v-model="data.navigateTo"
                              placeholder="Enter Navigation URL"
                            ></b-form-input>
                          </b-col>
                          <b-col
                            md="6"
                            class="my-2"
                            v-if="data.radioCriteria == 'customCri'"
                          >
                            <b-row>
                              <b-col>
                                <label class="labelFont"
                                  >Select Navigation Type
                                </label>
                              </b-col>
                            </b-row>
                            <input
                              type="radio"
                              :id="`globalpage${idx}`"
                              value="GLOBAL"
                              v-model="data.appNavigate.type"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`globalpage${idx}`"
                              >Global</label
                            >
                            <input
                              type="radio"
                              :id="`partnerpage${idx}`"
                              value="PROVIDER"
                              v-model="data.appNavigate.type"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`partnerpage${idx}`"
                              >Partner</label
                            >
                            <input
                              type="radio"
                              :id="`marketpage${idx}`"
                              value="MARKET"
                              v-model="data.appNavigate.type"
                            />
                            <label
                              class="pl-1 pr-3 labelFont"
                              :for="`marketpage${idx}`"
                              >Market</label
                            >
                          </b-col>
                          <b-col
                            md="6"
                            v-if="
                              data.appNavigate.type == 'PROVIDER' &&
                              data.radioCriteria != 'navUrl'
                            "
                          >
                            <eb-select
                              placeholder="Select Partner"
                              type="text"
                              v-model="data.appNavigate.id"
                              :options="partnerList"
                              label="userName"
                            ></eb-select>
                          </b-col>
                          <b-col
                            md="6"
                            v-if="
                              data.appNavigate.type == 'MARKET' &&
                              data.radioCriteria != 'navUrl'
                            "
                          >
                            <eb-select
                              placeholder="Select Market"
                              type="text"
                              v-model="data.appNavigate.id"
                              :options="catalogList"
                              label="label"
                            ></eb-select>
                          </b-col>
                          <b-col
                            md="6"
                            v-if="
                              data.radioCriteria == 'customCri' &&
                              data.appNavigate.type
                            "
                          >
                            <input
                              class="atCenter"
                              type="checkbox"
                              id="customSearch"
                              value="true"
                            />
                            <label class="labelFont pl-1" for="customSearch"
                              >Enable Custom Search</label
                            >
                          </b-col>
                          <b-col
                            md="5"
                            v-if="
                              data.radioCriteria == 'customCri' &&
                              data.appNavigate.type
                            "
                            style="width: 608px"
                          >
                            <eb-select
                              class="mb-0"
                              type="text"
                              v-model="selectedCriteria"
                              :options="criteriaOptions"
                              label="label"
                              placeholder="Select Criteria"
                            ></eb-select>
                          </b-col>
                          <b-col
                            md="1"
                            v-if="
                              data.radioCriteria == 'customCri' &&
                              data.appNavigate.type
                            "
                            style="width: 608px"
                          >
                            <b-button
                              :disabled="selectedCriteria == ''"
                              variant="primary"
                              class="circularBtn"
                              @click="handleAddCriteria(data, idx)"
                            >
                              <span>
                                <i class="fa fa-plus" aria-hidden="true"></i>
                              </span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            md="6"
                            v-for="(
                              criteria, index
                            ) in data.allSelectedCriteria"
                            :key="index"
                          >
                            <b-row>
                              <template v-if="criteria.value == 'name'">
                                <b-col md="10" class="my-2">
                                  <b-form-input
                                    inputType="text"
                                    v-model="data.appNavigate.filterParams.name"
                                    placeholder="Enter Name"
                                  ></b-form-input>
                                </b-col>
                                <b-col md="2">
                                  <b-button
                                    @click="
                                      removeCriteria(data, index, criteria)
                                    "
                                    variant="danger"
                                    class="circularBtn my-2"
                                  >
                                    <span>
                                      <i
                                        class="fa fa-minus"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </b-button>
                                </b-col>
                              </template>
                            </b-row>
                            <b-row>
                              <template v-if="criteria.value == 'Discount'">
                                <b-col md="10" class="my-2">
                                  <b-form-input
                                    type="number"
                                    v-model="
                                      data.appNavigate.filterParams.Discount
                                    "
                                    placeholder="Enter Discount"
                                  ></b-form-input>
                                </b-col>
                                <b-col md="2">
                                  <b-button
                                    @click="
                                      removeCriteria(data, index, criteria)
                                    "
                                    variant="danger"
                                    class="circularBtn my-2"
                                  >
                                    <span>
                                      <i
                                        class="fa fa-minus"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </b-button>
                                </b-col>
                              </template>
                            </b-row>
                            <b-row>
                              <template
                                v-if="criteria.value == 'descriptionSummary'"
                              >
                                <b-col md="10" class="my-2">
                                  <b-form-input
                                    inputType="text"
                                    v-model="
                                      data.appNavigate.filterParams
                                        .descriptionSummary
                                    "
                                    placeholder="Enter Description Summary"
                                  ></b-form-input>
                                </b-col>
                                <b-col md="2">
                                  <b-button
                                    @click="
                                      removeCriteria(data, index, criteria)
                                    "
                                    variant="danger"
                                    class="circularBtn my-2"
                                  >
                                    <span>
                                      <i
                                        class="fa fa-minus"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </b-button>
                                </b-col>
                              </template>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-collapse>
                      <hr
                        v-if="
                          inputObject.type.value === 'SLIDER' &&
                          bannerType != ''
                        "
                        class="dashed-line"
                      />
                    </div>
                  </b-card>
                  <b-row class="py-5 text-align-center justify-content-center">
                    <b-col md="3">
                      <b-button
                        class="btn btn-block my-3"
                        btn-color="secondary"
                        @click="currentstepper = 1"
                        >BACK</b-button
                      >
                    </b-col>
                    <b-col md="3">
                      <b-button
                        class="btn btn-block my-3"
                        btn-color="primary"
                        @click="createAd"
                        >CREATE ADVERTISEMENT</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
import DatePicker from "vuejs-datepicker";
import ebSelect from "@/components/FormElements/Select.vue";
import locationMixins from "@/mixins/addressLocation";
import { mapActions, mapGetters } from "vuex";
import SingleImage from "../../components/Common/Image.vue";
import SingleVideo from "../../components/Common/Video.vue";
import loader from "@/components/loader/nipigeloader.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "CreateAdvertisement",
  data() {
    return {
      advanceSetting: false,
      selectAge: true,
      allChecked: "",
      currentstepper: 1,
      selectedCriteria: "",
      providerCriteriaList: [],
      catalogList: [],
      bannerType: [],
      muteSound: "",
      tag: "",
      loading: false,
      visibilityType: "",
      inputObject: {
        type: "",
        placement: "",
        duration: {
          startDate: "",
          endDate: "",
        },
        data: [
          {
            video: {
              type: "",
              url: "",
            },
            image: {},
            lang: "en",
            text: "",
            contentPosition: "",
            radioCriteria: "",
            allSelectedCriteria: [],
            navigateTo: "",
            appNavigate: {
              id: "",
              name: "",
              type: "",
              filterParams: {},
            },
          },
        ],
        createdBy: {
          _id: "",
          name: "",
          email: "",
          phone: "",
          category: "",
        },
        icon: "",
        tag: [],
        target: {
          visibility: {
            id: "",
            type: "",
          },
          ageGroup: {
            min: "",
            max: "",
          },
          days: [],
          timeRange: [
            {
              start: "",
              end: "",
            },
          ],
          displayFrequency: "",
          location: {
            coordinates: [],
          },
          address: {
            city: "",
            state: "",
            country: "",
          },
          locationRadius: 100,
        },
      },
    };
  },
  mixins: [locationMixins],
  components: {
    cInput,
    DatePicker,
    ebSelect,
    SingleImage,
    SingleVideo,
    loader,
    VueEditor,
  },
  methods: {
    ...mapActions({
      CreateAd: "advertisement/createAd",
      UploadImage: "inventory/uploadImageToStorage",
    }),
    handleAdvanceSetting() {
        (this.inputObject.target.timeRange[0].start = ""),
        (this.inputObject.target.timeRange[0].end = ""),
        (this.inputObject.target.days = []),
        (this.allChecked = false);
    },
    clickUploadImage(idx) {
      try {
        this.$refs[`imageUploader${idx}`][0].click();
      } catch (error) {}
    },
    clickUploadVideo(idx) {
      try {
        this.$refs[`videoUploader${idx}`][0].click();
      } catch (error) {}
    },
    changeVisibility(e) {
      this.inputObject.target.visibility = {};
      this.inputObject.target.visibility.type = e.keys;
    },
    changePartner(e) {
      this.inputObject.target.visibility.id = e._id;
    },
    changeMarket(e) {
      this.inputObject.target.visibility.id = e.value;
    },
    handleChecked() {
      if (this.allChecked) {
        this.inputObject.target.days = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];
      } else if (!this.allChecked) {
        this.inputObject.target.days = [];
      }
    },
    handleUnChecked() {
      if (this.allChecked && this.inputObject.target.days.length != 7) {
        this.allChecked = false;
      } else if (!this.allChecked && this.inputObject.target.days.length == 7) {
        this.allChecked = true;
      }
    },
    handleAddCriteria(data) {
      if (!data?.allSelectedCriteria?.includes(this.selectedCriteria)) {
        data?.allSelectedCriteria?.push(this.selectedCriteria);
        data.appNavigate.filterParams[this.selectedCriteria.value] = "";
        this.selectedCriteria = "";
      }
    },
    removeCriteria(data, index, criteriaValue) {
      this.selectedCriteria = criteriaValue;
      data?.allSelectedCriteria?.splice(index, 1);
      delete data?.appNavigate?.filterParams[criteriaValue.value];
      this.selectedCriteria = "";
    },
    hideSelectedVideo(data) {
      data.video.url = "";
    },
    hideCustomCriteria(data) {
      data.allSelectedCriteria = [];
      data.appNavigate.type = "";
      data.appNavigate.id = "";
    },
    hideNavUrl(data) {
      data.allSelectedCriteria = [];
      data.navigateTo = "";
    },
    nextPage() {
      if (this.inputObject.type != "") {
        this.currentstepper = 2;
        window.scrollTo(0, 0);
      } else {
        this.$swal({
          title: "Warning",
          text: "Please Select Banner Type.",
          type: "warning",
        });
      }
    },
    async getCatalogList() {
      this.loading = true;
      if (this.GetCategoryList.status == 200) {
        if (this.GetCategoryList.data.response) {
          let data = this.GetCategoryList?.data?.response;
          let listItem = data.filter((item) => {
            return item.isMarket == true;
          });
          this.catalogList = listItem.map((item) => ({
            value: item._id,
            label: item?.catalogDescription?.displayName || "",
          }));
        }
      } else {
        await this.$store
          .dispatch("catalog/fetchCatalogList", "")
          .then((result) => {
            if (result.status === 200) {
              if (result.data.response) {
                let data = result?.data?.response;
                let listItem = data.filter((item) => {
                  return item.isMarket == true;
                });
                this.catalogList = listItem.map((item) => ({
                  value: item._id,
                  label: item?.catalogDescription?.displayName || "",
                }));
              }
            }
          })
          .catch((error) => {
            this.$swal({
              title: "Oops",
              text: error.message ? error.message : "Something went wrong",
              type: "error",
            });
          });
      }
      this.loading = false;
    },
    createAd() {
      this.loading = true;
      let payload = {
        ...this.inputObject,
      };
      if (payload?.type?.value) {
        payload.type = payload?.type?.value;
      } else {
        payload.type = payload.type;
      }
      payload.target.visibility = payload?.target?.visibility;

      if (payload?.target?.visibility?.type == "PROVIDER") {
        payload.target.visibility.id = this.visibilityType._id
          ? this.visibilityType._id
          : this.visibilityType.id;
      } else if (payload?.target?.visibility?.type == "MARKET") {
        payload.target.visibility.id = this.visibilityType.value;
      }

      if (this.$currentUserData.category === "SELLER") {
        payload.placement = payload.placement;
      } else {
        payload.placement = payload?.placement?.value;
      }
      if (
        payload?.target?.displayFrequency &&
        payload?.target?.displayFrequency?.value
      ) {
        payload.target.displayFrequency =
          payload?.target?.displayFrequency?.value;
      } else {
        payload.target.displayFrequency = payload?.target?.displayFrequency;
      }
      payload.tenant = this.$store.getters["auth/getUserID"];
      payload.createdBy._id = this.$currentUserData._id;
      payload.createdBy.name = this.$currentUserData.userName;
      payload.createdBy.email = this.$currentUserData.email;
      payload.createdBy.phone = this.$currentUserData.phone;
      payload.createdBy.category = this.$currentUserData.category;
      payload.data = [];

      this.inputObject.data.map((obj) => {
        if (obj.image && obj.navigateTo) {
          payload.data.push({
            image: obj.image,
            navigateTo: obj.navigateTo,
            lang:
              typeof obj.lang === "object" && obj.lang !== null
                ? obj.lang.value
                : "en",
            text: obj.text,
            contentPosition: obj.contentPosition,
          });
        } else if (obj.image && obj.appNavigate) {
          payload.data.push({
            image: obj.image,
            appNavigate: {
              id: obj.appNavigate?.id?._id
                ? obj.appNavigate?.id?._id
                : obj.appNavigate?.id?.value,
              type: obj?.appNavigate?.type,
              name:
                obj.appNavigate?.type == "PROVIDER"
                  ? obj.appNavigate?.id?.userName
                  : obj.appNavigate?.id?.label,
              filterParams: obj.appNavigate?.filterParams,
            },
            lang:
              typeof obj.lang === "object" && obj.lang !== null
                ? obj.lang?.value
                : "en",
            text: obj.text,
            contentPosition: obj.contentPosition,
          });
        } else if (obj.video && obj.navigateTo) {
          payload.data.push({
            video: {
              type: obj.video.type,
              url: obj.video.url,
            },
            navigateTo: obj.navigateTo,
            lang:
              typeof obj.lang === "object" && obj.lang !== null
                ? obj.lang?.value
                : "en",
          });
        } else if (obj.video && obj.appNavigate) {
          payload.data.push({
            video: {
              type: obj.video.type,
              url: obj.video.url,
            },
            appNavigate: {
              id: obj.appNavigate?.id?._id
                ? obj.appNavigate?.id?._id
                : obj.appNavigate?.id?.value,
              type: obj.appNavigate?.type,
              name:
                obj.appNavigate.type == "PROVIDER"
                  ? obj.appNavigate?.id?.userName
                  : obj.appNavigate?.id?.label,
              filterParams: obj.appNavigate?.filterParams,
            },
            lang:
              typeof obj.lang === "object" && obj.lang !== null
                ? obj.lang?.value
                : "en",
          });
        }
      });
      this.CreateAd(payload, "CreateAd")
        .then((res) => {
          this.$swal({
            title: "Success",
            text: "Advertisement has been created successfully",
            type: "success",
          });
          this.$router.push({ path: "/advertisement" });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    changeTags(tags) {
      this.inputObject.tag = [];
      this.inputObject.tag = tags.map(({ text }) => text);
    },
    changeType(event) {
      if (event.value === "SLIDER") {
        this.inputObject.data = [];
      } else if (event.value === "BANNER") {
        this.inputObject.data = [];
        this.inputObject?.data?.push({
          url: "",
          lang: "en",
          text: "",
          contentPosition: "",
          navigateTo: "",
          appNavigate: {
            id: "",
            type: "",
            name: "",
            filterParams: {},
          },
        });
      } else if (event.value === "VIDEO") {
        this.inputObject.data = [];
        this.inputObject?.data?.push({
          video: {
            type: "",
            url: "",
          },
          lang: "en",
          navigateTo: "",
          appNavigate: {
            id: "",
            type: "",
            name: "",
            filterParams: {},
          },
        });
      }
    },
    addNewBannerSlider(sliderType) {
      this.bannerType.push(sliderType);
      this.inputObject?.data?.push({
        url: "",
        lang: "",
        text: "",
        contentPosition: "",
        radioCriteria: "",
        allSelectedCriteria: [],
        navigateTo: "",
        appNavigate: {
          id: "",
          type: "",
          name: "",
          filterParams: {},
        },
      });
    },
    addNewVideoSlider(sliderType) {
      this.bannerType.push(sliderType);
      this.inputObject?.data?.push({
        video: {
          type: "",
          url: "",
        },
        lang: "",
        radioCriteria: "",
        navigateTo: "",
        allSelectedCriteria: [],
        appNavigate: {
          id: "",
          type: "",
          name: "",
          filterParams: {},
        },
      });
    },
    removeBanner(index) {
      this.bannerType.splice(index, 1);
      this.inputObject?.data?.splice(index, 1);
    },
    readImage(e, idx) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadFile(idx, reader.result, "image");
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },

    readVideo(e, idx) {
      if (e.target.files.length != 0) {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("isPublic", "true");
        formData.append("replaceExisting", "true");
        formData.append("basePath", "advertisement");
        formData.append(
          "key",
          (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          ).toLowerCase()
        );
        this.uploadFile(idx, formData, "video");
      }
    },

    async uploadFile(idx, file, type) {
      if (type == "video") {
        await this.$store
          .dispatch("inventory/uploadVideoToStorage", file)
          .then((res) => {
            this.inputObject?.data?.map((obj, index) => {
              if (index === idx) {
                obj.video.url = res.data?.fileUrl;
              }
            });
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
      } else if (type != "video") {
        let dataobj = {
          image: file,
          key: (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          ).toLowerCase(),
          isPublic: true,
          replaceExisting: true,
          basePath: "advertisement",
        };
        await this.$store
          .dispatch("inventory/uploadImageToStorage", dataobj)
          .then((res) => {
            if (type === "image") {
              this.inputObject?.data?.map((obj, index) => {
                if (index === idx) {
                  obj.image = res.data;
                }
                this.inputObject.data = [...this.inputObject.data];
              });
            } else if (type === "icon") {
              this.inputObject.icon = res.data;
            }
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
      }
    },
    readIcon(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadFile({}, reader.result, "icon");
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },
    getPlacementList() {
      if (this.$userRole === "Tenant") {
        this.$store.dispatch("advertisement/getPlacementList", "Tenant");
      } else {
        this.$store.dispatch("getPlacementList/getPlacementList", "Partner");
      }
    },
    backButton() {
      this.$router.push({ path: "/advertisement" });
    },
  },
  computed: {
    ...mapGetters({
      PlacementList: "advertisement/GetPlacementList",
      provider: "auth/getUserID",
      EntitiesList: "advertisement/GetEntities",
      GetCategoryList: "catalog/GetCategoryList",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    criteriaOptions() {
      let entityOption = [];
      this.EntitiesList?.key?.map((option) => {
        entityOption.push({
          label: option.toUpperCase(),
          value: option,
        });
      });
      return entityOption;
    },
    placementList() {
      let data = this.PlacementList;
      this.loading = false;
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            label: d.name.toUpperCase(),
            value: d.name,
          };
        });
      }
      return [];
    },

    placementListseller() {
      if (this.$currentUserData.category === "SELLER") {
        return ["SHOP_TOP"];
      } else {
        return [
          "MARKET_TOP",
          "SHOP_TOP",
          "TOP_MOBILE_BANNER",
          "placementone",
          "HOME_TOP",
          "HOME_BOTTOM",
          "HOME_SECTION_1",
          "HOME_SECTION_2",
          "DETAIL_SECTION",
        ];
      }
    },

    adtypes() {
      return [
        {
          label: "Banner",
          value: "BANNER",
        },
        {
          label: "Slider",
          value: "SLIDER",
        },
        {
          label: "Video",
          value: "VIDEO",
        },
      ];
    },

    frequencyOptions() {
      return [
        {
          label: "Two",
          value: 2,
        },
        {
          label: "Three",
          value: 3,
        },
        {
          label: "Four",
          value: 4,
        },
        {
          label: "Five",
          value: 5,
        },
        {
          label: "Six",
          value: 6,
        },
        {
          label: "Seven",
          value: 7,
        },
        {
          label: "Eight",
          value: 8,
        },
        {
          label: "Nine",
          value: 9,
        },
        {
          label: "Ten",
          value: 10,
        },
      ];
    },
    position() {
      let mapposition = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapposition.Lat) {
        this.inputObject.target.address.city = mapposition.data?.City
          ? mapposition.data?.City?.toUpperCase()
          : "";
        this.inputObject.target.address.state = mapposition.data?.State
          ? mapposition.data?.State?.toUpperCase()
          : "";
        this.inputObject.target.address.country = mapposition.data?.Country
          ? mapposition.data?.Country?.toUpperCase()
          : "";
        this.inputObject.target.location.coordinates = [
          mapposition.Lng,
          mapposition.Lat,
        ];
        return { lng: mapposition.Lng, lat: mapposition.Lat };
      } else {
        return { lng: 0, lat: 0 };
      }
    },
    visibilityOptions() {
      if (this.$userRole == "Tenant") {
        return [
          {
            name: "Global",
            keys: "GLOBAL",
          },
          {
            name: "Partner",
            keys: "PROVIDER",
          },
          {
            name: "Market",
            keys: "MARKET",
          },
        ];
      }
      if (this.$userRole == "Partner") {
        return [
          {
            name: "Market",
            keys: "MARKET",
          },
        ];
      }
    },
    languageOptions() {
      return [
        {
          label: "English",
          value: "en",
        },
        {
          label: "Bengali",
          value: "bn",
        },
        {
          label: "Telugu",
          value: "te",
        },
        {
          label: "Hindi",
          value: "hi",
        },
      ];
    },
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      let providerPartnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            userName: obj.authentication?.userName,
            email: obj.authentication?.email,
            phone: obj.authentication?.phone,
            ...obj,
          };
          partnerList.push(arrayObj);
        });
        partnerList.filter((criteriaObj) => {
          if (criteriaObj.category == "SELLER") {
            providerPartnerList.push(criteriaObj);
          }
        });
        this.providerCriteriaList = [];
        providerPartnerList.map((mapObj) => {
          let mapArrObj = {
            value: mapObj._id,
            label: mapObj.userName,
          };
          this.providerCriteriaList.push(mapArrObj);
        });
        return partnerList;
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.$store.dispatch("item/setItemCatalogLocation", {});
    if (this.$currentUserData.category === "SELLER") {
      this.$store.dispatch("partner/fetchPartnersList");
    } else if (this.$currentUserData.category === "TA") {
      this.$store.dispatch("partner/fetchTenantPartnersList", {
        category: "SELLER",
      });
    }
    this.getPlacementList();
    this.getCatalogList();
    let payload = { label: "ITEM" };
    this.$store.dispatch("advertisement/fetchEntities", payload);
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  background-color: #727cf5;
}

.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
</style>
<style>
.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
.v-stepper {
  box-shadow: none;
}

.v-stepper__header {
  box-shadow: none;
}

.v-btn:before {
  opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 0px;
}

.v-stepper-step-outline {
  border: 1px solid #727cf5 !important;
  height: 0px;
  border-radius: 50%;
  width: 0px;
  margin-top: 8px;
  margin-bottom: 40px;
  float: left;
}
@-moz-document url-prefix() {
  .v-stepper-step-outline {
    padding: 24px 4px 24px 4px;
  }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  color: #ffffff;
  background-color: #727cf5 !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
  margin-right: 0;
  margin-top: -21px;
}
.v-stepper__step__step {
  min-height: 42px;
  min-width: 42px !important;
}
.v-stepper__content {
  padding: 0px !important;
}
/* Deactive Stepper */
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: #8badd6 !important;
}
/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px 0px;
  -ms-flex-item-align: start;
  align-self: flex-start;
}
.labelFont {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  /* font-weight: 500; */
}
.v-stepper__label {
  width: max-content;
}
.vue-tags-input {
  max-width: none !important;
  position: relative;
  background-color: #fff;
}
.circularBtn {
  height: 40px;
  width: 40px;
  border-radius: 100%;
  text-align: center;
}
.sliderOption {
  border-radius: 4px;
  width: 196px;
}
.collapsed > .when-closed,
:not(.collapsed) > .when-open {
  display: none;
}
.dashed-line {
  border: 1px dashed rgb(223, 225, 233);
}
.form-group.text-muted.v-select.vs--searchable.vs--single {
  margin-bottom: 0px;
}
.atCenter {
  margin-top: 12px;
}
.singleImage {
  height: 200px;
  border-radius: 12px;
  border: 1px dashed #3635d3 !important;
  background-color: #e9e7ff;
}
.singleIcon {
  height: 120px;
  width: 120px;
  border-radius: 12px;
  border: 1px dashed #3635d3 !important;
  background-color: #e9e7ff;
}
.composeText {
  border: 1px solid gray;
  border-radius: 0px 0px 5px 5px;
  padding: 6px;
  padding-right: 9px;
  outline: none;
}
.sliderButton {
  text-align: end;
}
.textMenu {
  background-color: #fafbfe;
  border-radius: 5px 5px 0px 0px;
  height: 40px;
  border: 1px solid black;
  border-bottom: 0px;
}
</style>
